<template>
  <div id="NotFoundComponent">
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss">
#NotFoundComponent{
  height: 600px;
  background-size: auto 100%;
  background-position:center;
  background-repeat: no-repeat;
  background-image: url(../assets/images/404.jpg);
}
</style>



// WEBPACK FOOTER //
// src/pages/NotFoundComponent.vue